import { useQuery } from '@tanstack/react-query';
import { useMedplum, useMedplumProfile } from '@medplum/react';
import type { Parameters } from '@medplum/fhirtypes';

import { permissionsQueryKey, parsePermissionsResponse } from '@/lib/auth/permissions';

/**
 * Shared TanStack Query for the User/$get-permissions bootstrap. Both
 * usePermissions and useFeatureFlags read from this single cache entry, so the
 * permissions and feature flags ride one request.
 */
export function usePermissionsQuery() {
  const medplum = useMedplum();
  const profile = useMedplumProfile();

  const practitionerId = profile?.resourceType === 'Practitioner' ? profile.id : undefined;

  return useQuery({
    queryKey: permissionsQueryKey(practitionerId),
    queryFn: async () => {
      const result = (await medplum.get(
        medplum.fhirUrl('User', '$get-permissions').toString(),
      )) as Parameters;
      return parsePermissionsResponse(result);
    },
    enabled: !!practitionerId,
    staleTime: Number.POSITIVE_INFINITY,
  });
}
